/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateUser = /* GraphQL */ `
  subscription OnCreateUser {
    onCreateUser {
      id
      companyId
      firstName
      lastName
      email
      phone
      userType {
        userType
      }
      isActive
      imageUrl
      emailSentOn
      emailVerifiedOn
      isVerified
      lastActiveOn
      updatedAt
      company {
        id
        name
        email
        phone
        address
        state
        city
        zip
        referralCode
        users {
          nextToken
        }
        meetings {
          nextToken
        }
        teams {
          nextToken
        }
        createdAt
        updatedAt
      }
      team {
        items {
          id
          teamUserUserId
          teamUserTeamId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
    }
  }
`;
export const onUpdateUser = /* GraphQL */ `
  subscription OnUpdateUser {
    onUpdateUser {
      id
      companyId
      firstName
      lastName
      email
      phone
      userType {
        userType
      }
      isActive
      imageUrl
      emailSentOn
      emailVerifiedOn
      isVerified
      lastActiveOn
      updatedAt
      company {
        id
        name
        email
        phone
        address
        state
        city
        zip
        referralCode
        users {
          nextToken
        }
        meetings {
          nextToken
        }
        teams {
          nextToken
        }
        createdAt
        updatedAt
      }
      team {
        items {
          id
          teamUserUserId
          teamUserTeamId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
    }
  }
`;
export const onDeleteUser = /* GraphQL */ `
  subscription OnDeleteUser {
    onDeleteUser {
      id
      companyId
      firstName
      lastName
      email
      phone
      userType {
        userType
      }
      isActive
      imageUrl
      emailSentOn
      emailVerifiedOn
      isVerified
      lastActiveOn
      updatedAt
      company {
        id
        name
        email
        phone
        address
        state
        city
        zip
        referralCode
        users {
          nextToken
        }
        meetings {
          nextToken
        }
        teams {
          nextToken
        }
        createdAt
        updatedAt
      }
      team {
        items {
          id
          teamUserUserId
          teamUserTeamId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
    }
  }
`;
export const onCreateCompany = /* GraphQL */ `
  subscription OnCreateCompany {
    onCreateCompany {
      id
      name
      email
      phone
      address
      state
      city
      zip
      referralCode
      users {
        items {
          id
          companyId
          firstName
          lastName
          email
          phone
          isActive
          imageUrl
          emailSentOn
          emailVerifiedOn
          isVerified
          lastActiveOn
          updatedAt
          createdAt
        }
        nextToken
      }
      meetings {
        items {
          id
          companyId
          title
          date
          shortId
          teamId
          meta
          createdAt
          updatedAt
        }
        nextToken
      }
      teams {
        items {
          id
          companyId
          name
          color
          icon
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCompany = /* GraphQL */ `
  subscription OnUpdateCompany {
    onUpdateCompany {
      id
      name
      email
      phone
      address
      state
      city
      zip
      referralCode
      users {
        items {
          id
          companyId
          firstName
          lastName
          email
          phone
          isActive
          imageUrl
          emailSentOn
          emailVerifiedOn
          isVerified
          lastActiveOn
          updatedAt
          createdAt
        }
        nextToken
      }
      meetings {
        items {
          id
          companyId
          title
          date
          shortId
          teamId
          meta
          createdAt
          updatedAt
        }
        nextToken
      }
      teams {
        items {
          id
          companyId
          name
          color
          icon
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCompany = /* GraphQL */ `
  subscription OnDeleteCompany {
    onDeleteCompany {
      id
      name
      email
      phone
      address
      state
      city
      zip
      referralCode
      users {
        items {
          id
          companyId
          firstName
          lastName
          email
          phone
          isActive
          imageUrl
          emailSentOn
          emailVerifiedOn
          isVerified
          lastActiveOn
          updatedAt
          createdAt
        }
        nextToken
      }
      meetings {
        items {
          id
          companyId
          title
          date
          shortId
          teamId
          meta
          createdAt
          updatedAt
        }
        nextToken
      }
      teams {
        items {
          id
          companyId
          name
          color
          icon
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateTeamUser = /* GraphQL */ `
  subscription OnCreateTeamUser {
    onCreateTeamUser {
      id
      teamUserUserId
      teamUserTeamId
      user {
        id
        companyId
        firstName
        lastName
        email
        phone
        userType {
          userType
        }
        isActive
        imageUrl
        emailSentOn
        emailVerifiedOn
        isVerified
        lastActiveOn
        updatedAt
        company {
          id
          name
          email
          phone
          address
          state
          city
          zip
          referralCode
          createdAt
          updatedAt
        }
        team {
          nextToken
        }
        createdAt
      }
      team {
        id
        companyId
        name
        color
        icon
        user {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateTeamUser = /* GraphQL */ `
  subscription OnUpdateTeamUser {
    onUpdateTeamUser {
      id
      teamUserUserId
      teamUserTeamId
      user {
        id
        companyId
        firstName
        lastName
        email
        phone
        userType {
          userType
        }
        isActive
        imageUrl
        emailSentOn
        emailVerifiedOn
        isVerified
        lastActiveOn
        updatedAt
        company {
          id
          name
          email
          phone
          address
          state
          city
          zip
          referralCode
          createdAt
          updatedAt
        }
        team {
          nextToken
        }
        createdAt
      }
      team {
        id
        companyId
        name
        color
        icon
        user {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteTeamUser = /* GraphQL */ `
  subscription OnDeleteTeamUser {
    onDeleteTeamUser {
      id
      teamUserUserId
      teamUserTeamId
      user {
        id
        companyId
        firstName
        lastName
        email
        phone
        userType {
          userType
        }
        isActive
        imageUrl
        emailSentOn
        emailVerifiedOn
        isVerified
        lastActiveOn
        updatedAt
        company {
          id
          name
          email
          phone
          address
          state
          city
          zip
          referralCode
          createdAt
          updatedAt
        }
        team {
          nextToken
        }
        createdAt
      }
      team {
        id
        companyId
        name
        color
        icon
        user {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateTeam = /* GraphQL */ `
  subscription OnCreateTeam {
    onCreateTeam {
      id
      companyId
      name
      color
      icon
      user {
        items {
          id
          teamUserUserId
          teamUserTeamId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateTeam = /* GraphQL */ `
  subscription OnUpdateTeam {
    onUpdateTeam {
      id
      companyId
      name
      color
      icon
      user {
        items {
          id
          teamUserUserId
          teamUserTeamId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteTeam = /* GraphQL */ `
  subscription OnDeleteTeam {
    onDeleteTeam {
      id
      companyId
      name
      color
      icon
      user {
        items {
          id
          teamUserUserId
          teamUserTeamId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateMeeting = /* GraphQL */ `
  subscription OnCreateMeeting {
    onCreateMeeting {
      id
      companyId
      meetingType {
        meetingType
      }
      title
      date
      shortId
      teamId
      meta
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateMeeting = /* GraphQL */ `
  subscription OnUpdateMeeting {
    onUpdateMeeting {
      id
      companyId
      meetingType {
        meetingType
      }
      title
      date
      shortId
      teamId
      meta
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteMeeting = /* GraphQL */ `
  subscription OnDeleteMeeting {
    onDeleteMeeting {
      id
      companyId
      meetingType {
        meetingType
      }
      title
      date
      shortId
      teamId
      meta
      createdAt
      updatedAt
    }
  }
`;
export const onCreateAppLog = /* GraphQL */ `
  subscription OnCreateAppLog {
    onCreateAppLog {
      id
      message
      level
      madeBy
      meta
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateAppLog = /* GraphQL */ `
  subscription OnUpdateAppLog {
    onUpdateAppLog {
      id
      message
      level
      madeBy
      meta
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteAppLog = /* GraphQL */ `
  subscription OnDeleteAppLog {
    onDeleteAppLog {
      id
      message
      level
      madeBy
      meta
      createdAt
      updatedAt
    }
  }
`;
export const onCreateSettings = /* GraphQL */ `
  subscription OnCreateSettings($owner: String!) {
    onCreateSettings(owner: $owner) {
      id
      key
      val
      isActive
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateSettings = /* GraphQL */ `
  subscription OnUpdateSettings($owner: String!) {
    onUpdateSettings(owner: $owner) {
      id
      key
      val
      isActive
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteSettings = /* GraphQL */ `
  subscription OnDeleteSettings($owner: String!) {
    onDeleteSettings(owner: $owner) {
      id
      key
      val
      isActive
      createdAt
      updatedAt
      owner
    }
  }
`;
